var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    viewBox: "0 96 960 960",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M477.744 915.999q-135.205 0-232.487-92.308-97.281-92.307-104.717-227.588h50.665q8.128 113.769 89.962 191.705Q363 865.744 477.744 865.744q121.871 0 206.551-85.218 84.679-85.218 84.679-207.09 0-120.385-85.089-203.782-85.09-83.398-206.141-83.398-64.872 0-122.103 28.577-57.23 28.577-99.846 77.269h102.051v50.255H170.054V254.718h50.255v100.718q49.102-55.973 116.076-87.704 66.974-31.731 141.359-31.731 70.768 0 132.819 26.564 62.051 26.564 108.462 72.564 46.41 46 73.307 107.641 26.897 61.641 26.897 132.153 0 70.769-26.897 132.948t-73.307 108.256q-46.411 46.077-108.462 72.974-62.051 26.898-132.819 26.898Zm127.923-181.487-150-148.923V374.513h50.255v190.41l135.539 133.795-35.794 35.794Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHistory);
export default __webpack_public_path__ + "static/media/icon-history.9cd1b19848a72fa6e5605187c22159e1.svg";
export { ForwardRef as ReactComponent };